<script setup lang="ts">
withDefaults(defineProps<{
  readonly items: readonly string[]
  readonly variant?: 'customer' | 'personnel'
  readonly showMarkers?: boolean
}>(), { variant: 'customer' })
</script>

<template>
  <ul
    class="fw-welcome-checklist"
    :class="{ 'fw-welcome-checklist--personnel': variant === 'personnel', 'fw-welcome-checklist--markers': showMarkers }"
  >
    <li
      v-for="(item, index) in items"
      :key="index"
    >
      <template v-if="variant === 'personnel' || showMarkers">
        <span
          class="fw-welcome-checklist__tick"
          aria-hidden="true"
        >✓</span>
        <span>{{ item }}</span>
      </template>
      <template v-else>
        {{ item }}
      </template>
    </li>
  </ul>
</template>

<style scoped>
.fw-welcome-checklist {
  display: flex;
  flex-direction: column;
  gap: 9px;
  max-width: 46ch;
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 13.5px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.85);
}
/* FW-224 — personel rozetleri 18px yuvarlak kalir; musteri listesine eklenmez. */
.fw-welcome-checklist--personnel li, .fw-welcome-checklist--markers li { display: flex; gap: 11px; align-items: flex-start; }
.fw-welcome-checklist__tick { width: 18px; height: 18px; border-radius: 50%; background: rgba(255, 255, 255, 0.16); display: flex; align-items: center; justify-content: center; flex: none; font-size: 11px; margin-top: 2px; }
</style>
